export enum ExportFormat {
    MYOB = 'MYOB',
    Xero = 'Xero'
}
